import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const ImagesAtelier = ({ getOnlyFourItems }) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulAtelier(
        filter: { ordre: { gt: 0 } }
        sort: { fields: ordre, order: ASC }
      ) {
        edges {
          node {
            id
            titre
            couverture {
              fluid(quality: 90) {
                ...GatsbyContentfulFluid_withWebp_noBase64
              }
            }
            slug
          }
        }
      }
    }
  `)

  const itemsSize = getOnlyFourItems
    ? 4
    : data.allContentfulAtelier.edges.length

  return (
    <div className="images">
      {data.allContentfulAtelier.edges.slice(0, itemsSize).map(item => (
        <Link
          key={item.node.id}
          to={`/atelier/${item.node.slug}`}
          className="image"
        >
          <Img fluid={item.node.couverture.fluid} />
          {item.node.titre && <h3>{item.node.titre}</h3>}
        </Link>
      ))}
    </div>
  )
}

export default ImagesAtelier
